import { z } from 'zod'

const EncodedEntry = z
  .object({
    entry: z
      .object({
        data: z
          .object({
            source: z
              .object({ record_encoding: z.string().optional() })
              .passthrough(),
            record: z.record(z.string(), z.unknown()),
          })
          .passthrough(),
      })
      .passthrough(),
  })
  .passthrough()

function decodeFields(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(decodeFields)
  if (!value || typeof value !== 'object') return value
  return Object.fromEntries(
    Object.entries(value).map(([key, item]) => {
      if (
        (key === 'longdescription' || key.endsWith('_longdescription')) &&
        typeof item === 'string'
      ) {
        const bytes = Uint8Array.from(atob(item), (char) => char.charCodeAt(0))
        return [key, new TextDecoder('utf-8', { fatal: true }).decode(bytes)]
      }
      return [key, decodeFields(item)]
    })
  )
}

export function decodeCmmsEntry(value: unknown): unknown {
  const parsed = EncodedEntry.safeParse(value)
  if (!parsed.success || !parsed.data.entry.data.source.record_encoding)
    return value
  const { record_encoding, ...source } = parsed.data.entry.data.source
  if (record_encoding !== 'maximo-longdescription-base64-utf8-v1') return null
  try {
    return {
      ...parsed.data,
      entry: {
        ...parsed.data.entry,
        data: {
          ...parsed.data.entry.data,
          source,
          record: decodeFields(parsed.data.entry.data.record),
        },
      },
    }
  } catch {
    return null
  }
}
